import { defineStyle as e, defineStyleConfig as r } from "@chakra-ui/react";
import { cssVar as t } from "@chakra-ui/theme-tools";
const o = t("close-button-size"), a = e({
  color: "gray.700",
  w: [o.reference],
  h: [o.reference],
  borderRadius: "lg",
  transitionProperty: "common",
  transitionDuration: "normal",
  _disabled: {
    color: "gray.800",
    opacity: 0.5,
    cursor: "not-allowed",
    boxShadow: "none",
    _hover: { bg: "none" }
  },
  _hover: { bg: "blackAlpha.100" },
  _active: { bg: "blackAlpha.200" },
  _focusVisible: {
    boxShadow: "outline"
  }
}), i = {
  lg: e({
    [o.variable]: "40px",
    fontSize: "15px"
  }),
  md: e({
    [o.variable]: "32px",
    fontSize: "15px"
  }),
  sm: e({
    [o.variable]: "24px",
    fontSize: "10px"
  })
}, s = r({
  baseStyle: a,
  sizes: i,
  defaultProps: {
    size: "md"
  }
});
export {
  s as default
};
